import { Button } from '@/components/common/Button'

interface TokenPaginationProps {
  total: number
  currentPage: number
  pageSize?: number
  onPageChange: (page: number) => void
}

export function TokenPagination({
  total,
  currentPage,
  pageSize = 50,
  onPageChange,
}: TokenPaginationProps) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize))

  const handlePageChange = (page: number) => {
    if (page >= 1 && page <= totalPages) {
      onPageChange(page)
    }
  }

  const startToken = (currentPage - 1) * pageSize + 1
  const endToken = Math.min(currentPage * pageSize, total)

  return (
    <div className="flex items-center justify-between px-4 py-2 bg-gray-50 border-t">
      <div className="text-sm text-gray-600">
        {total > 0 ? `${startToken}-${endToken} von ${total} Token` : 'Keine Token'}
      </div>
      <div className="flex items-center gap-2">
        <Button
          variant="outline"
          size="sm"
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          Zurück
        </Button>
        <span className="text-sm text-gray-600">
          {currentPage} / {totalPages}
        </span>
        <Button
          variant="outline"
          size="sm"
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          Weiter
        </Button>
      </div>
    </div>
  )
}
